module.exports = __webpack_public_path__ + "img/Group258.5246703a.png";